import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=cfb20320&scoped=true&"
import script from "./CompanyIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIndex.vue?vue&type=style&index=0&id=cfb20320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb20320",
  null
  
)

export default component.exports